import { Component, OnInit } from '@angular/core';
import { AdminService } from '../admin.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {

  createUserForm: FormGroup;
  public onHide: Subject<boolean>;
  isCreateBtnDisabled: boolean;

  constructor(private adminService: AdminService,
              private bsModalRef: BsModalRef,
              private fb: FormBuilder,
              private toastr: ToastrService) {
  }

  ngOnInit() {
    this.createUserForm = this.fb.group({
        username: new FormControl('', Validators.minLength(4)),
        email: new FormControl('', Validators.email),
        password: new FormControl('', [Validators.required, Validators.minLength(8)]),
        passwordAgain: new FormControl('', [Validators.required, Validators.minLength(8)]),
        abosId: new FormControl()
      }
    );

    this.onHide = new Subject();
  }

  create() {
    if (this.createUserForm.invalid) {
      return;
    }
    this.isCreateBtnDisabled = true;
    this.adminService.createUser(this.createUserForm.getRawValue()).subscribe(() => {
      this.onHide.next(true);
      this.isCreateBtnDisabled = false;
      this.bsModalRef.hide();
    }, err => {
      this.isCreateBtnDisabled = false;
      this.toastr.error(err.error.message);
    });
  }

  cancelNewUserModal() {
    this.bsModalRef.hide();
  }
}
